import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { API_SCHEME, API_HOST, API_PATH } from 'utils/env';

const baseURI = 'catalogos/historico-modificacion-de-jornada-vista-optimized';

/**
 * GET Historicos Movimientos Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
const getHistoricosModificacionJornadasOptimized = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export default getHistoricosModificacionJornadasOptimized;
